import 'core-js/stable'
import 'mutationobserver-shim'
import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './vuex'
import vuetify from './plugins/vuetify'

Vue.config.productionTip = false

Vue.filter('formatDate', function(value) {
  if (!value) return ''
  let current_datetime = new Date(value.toString())
  let formatted_date =
    ('0' + current_datetime.getDate()).slice(-2) +
    '/' +
    ('0' + (current_datetime.getMonth() + 1)).slice(-2) +
    '/' +
    current_datetime.getFullYear()
  return formatted_date
})

new Vue({
  router,
  store,
  created() {
    const userString = localStorage.getItem('user')
    if (userString) {
      const userData = JSON.parse(userString)
      this.$store.commit('SET_USER_DATA', userData)
    }
  },
  vuetify,
  render: h => h(App)
}).$mount('#app')
